var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-print-4972218",
    transform: "translate(-129.972 -59.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17366",
    "data-name": "Path 17366",
    d: "M148.268,63.522h-1.176V61.793a1.832,1.832,0,0,0-1.83-1.83h-10.58a1.832,1.832,0,0,0-1.83,1.83v1.729h-1.176a1.706,1.706,0,0,0-1.7,1.7V74.7a1.706,1.706,0,0,0,1.7,1.7h1.176v2.207a1.353,1.353,0,0,0,1.351,1.351h11.537a1.353,1.353,0,0,0,1.351-1.351V76.4h1.176a1.706,1.706,0,0,0,1.7-1.7V65.225a1.707,1.707,0,0,0-1.7-1.7ZM134.1,61.793a.581.581,0,0,1,.58-.58h10.58a.581.581,0,0,1,.58.58v1.729H134.1Zm11.739,16.819a.1.1,0,0,1-.1.1H134.2a.1.1,0,0,1-.1-.1V72.235a.1.1,0,0,1,.1-.1h11.537a.1.1,0,0,1,.1.1v6.377Zm2.88-3.912a.454.454,0,0,1-.454.454h-1.176V72.235a1.353,1.353,0,0,0-1.351-1.351H134.2a1.353,1.353,0,0,0-1.351,1.351v2.919h-1.176a.454.454,0,0,1-.454-.454V65.226a.454.454,0,0,1,.454-.454h16.592a.454.454,0,0,1,.454.454Zm-1.63-8.018a.625.625,0,0,1-.625.625h-2.755a.625.625,0,0,1,0-1.25h2.755A.625.625,0,0,1,147.092,66.682Z",
    fill: "#3b4452"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinticon);
export default __webpack_public_path__ + "static/media/printicon.e6710964a7df05432ddf57302be408af.svg";
export { ForwardRef as ReactComponent };